import { useRouter } from 'next/router';

export const useIsSplitBillPage = () => {
  const router = useRouter();

  return router.route === '/[locationSlug]/[merchantSlug]/[merchantId]/split-by-amount';
};
